import { useAppSelector } from "@/shared/lib/redux"
import { ApexOptions } from "apexcharts"
import ReactApexChart from "react-apexcharts"
import { selectChannels, selectMarketingCampaignStatistics } from "@/entities/marketing-campaign"
import { useMemo } from "react"

export const ReferrerBarChart = () => {
    const statistics = useAppSelector(selectMarketingCampaignStatistics)
    const channels = useAppSelector(selectChannels)
    const labels = useMemo(() => statistics.map((statistics) => channels.find((channel) => channel.telegramId === statistics.channelId)?.name || "Неизвестный источник"), [channels, statistics])
    const series: ApexAxisChartSeries = [{
        name: "Количество переходов",
        data: statistics.map((statistics) => statistics.transitions)
    }]

    const options: ApexOptions = {
        chart: {
            type: 'bar',
            height: 350,
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
            colors: {
                ranges: [{
                    from: 0,
                    to: Infinity,
                    color: "#66D9C7"
                }]
            }
          }
        },
        labels,
        xaxis: {
            labels: {
                style: {
                    fontFamily: 'Manrope',
                    fontWeight: 700,
                    fontSize: '12px'
                }
            },
        },
        grid: {
            yaxis: {
                lines: {
                    show: false
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        yaxis: {
            labels: {
                style: {
                    fontFamily: 'Manrope',
                    fontWeight: 700,
                    fontSize: '12px'
                }
            },
        }
    }

    return (
        <div className='box'>
            <div className='box_header'>
                График переходов
            </div>
            <div className='bg-[#E7EAEE] mb-6 screen:mb-[32px] w-full h-[1px] block'/>
            <div id='chart' className={'min-h-[284px] h-[1px]'}>
                {Boolean(statistics.length)
                    ? <ReactApexChart options={options} series={series} type="bar" height='100%' />
                    : <div className="flex h-full items-center justify-center">
                        <div className="text-xl screen:text-2xl mb-10 font-mediumttf text-white bg-color-secondary rounded-2xl p-4 text-center">
                            НЕДОСТАТОЧНО ДАННЫХ <br />
                            ДЛЯ ФОРМИРОВАНИЯ <br />
                            СТАТИСТИКИ
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}